import TransactionLedger from "../components/TransactionLedger";
export default function ExpensesPage() {
  return <TransactionLedger type="expense" />;
}
